import ComponentLayout from "../../../../src/layouts/component-layout";
import doStackImages from "../../../../content/components/Pillar/images/do-stack-images.png";
import dontStackImages from "../../../../content/components/Pillar/images/dont-stack-images.png";
import * as React from 'react';
export default {
  ComponentLayout,
  doStackImages,
  dontStackImages,
  React
};